var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"controls"},[_c('a',{ref:"link",staticClass:"button",attrs:{"href":_vm.medium.link,"target":"_blank","rel":"noopener noreferrer"}},[_c('div',{staticClass:"dashicons dashicons-admin-links"})])])}
var staticRenderFns = []

export { render, staticRenderFns }